export interface ToastAction {
  label: string;
  onClick: () => void;
}

/** A toast's message, with an optional action ("Ver") at the end. */
export default function ToastBody({ message, action }: { message: string; action?: ToastAction }) {
  return (
    <div className="v-toast">
      <span>{message}</span>
      {action && (
        <button type="button" className="v-toast__action" onClick={action.onClick}>
          {action.label}
        </button>
      )}
    </div>
  );
}
